import { InsightsOutlined as BiDashboardIcon } from '@mui/icons-material';
import type { ReactNode } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';
import { IconAnalyticsDashboard } from '~/ui/core/icons';

import { SideDrawerLinkV2 } from '../app/app-bar/menu-bar-v2/SideDrawerLinkV2';
import { installationGuidePageRoute } from './constants';

export const useInstallationGuideListItem = (): ReactNode => {
    const {
        applicationState: { featureFlagService },
        translate,
    } = useApplicationContext();

    if (!featureFlagService.isFeatureFlagEnabled('installation-guide')) {
        return null;
    }

    return (
        <SideDrawerLinkV2
            key="installation-guide"
            externalUrl={false}
            Icon={BiDashboardIcon}
            label={translate('navigation.installation-guide')}
            NewIcon={IconAnalyticsDashboard}
            path={installationGuidePageRoute.patterns.installationGuide}
        />
    );
};
